
import { Avatar, Box, Card, Grid, styled, Typography } from "@mui/material"
import { useSelector } from "react-redux";
import { LayoutReturn } from "../../layouts";
import { CargandoMedio } from "../../components";

import carnet from '../../../assets/empresa/carnet.png';
const baseUrl = process.env.REACT_APP_API_URL;




const StyledCard = styled(Card)(() => ({
    width: '350px', 
    height: '500px', 
    maxWidth: '400px', 
    marginTop: '30px',
    borderRadius: 16,
    background: 'linear-gradient(to bottom right, #ffffff, #f8f9fa)',
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
    position: 'relative',
    overflow: 'visible',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
}));





export const MiCarnet = () => {

    
    const usuario = useSelector( state => state.admin );


    return (

        <LayoutReturn titulo="Mi Carnet" url={1}>
            <Grid container sx={{width:'100%', minHeight:'100vh', justifyContent:'center'}}>
                {(usuario)
                ?   <StyledCard sx={{backgroundImage:`url(${carnet})`}}>
                        <Box sx={{ position:'relative', width:'200px', height:'280px', margin:'0 auto', marginTop:'100px' }}>
                            <Box sx={{ width:'100%', height:'100%', border:'3px solid black', borderRadius:'65px', overflow:'hidden' }}>
                                <Avatar variant="square" sx={{ width: '100%', height: '100%', borderRadius: 0 }}
                                    src={`${ baseUrl }/uploads/usuarios/${ usuario.img }`}
                                />
                            </Box>

                            <Typography sx={{ position:'absolute', bottom:40, right:-60, fontWeight:900, padding:'4px 8px',
                                zIndex:70, fontSize:17, backgroundColor:'rgba(0, 0, 0, 0.7)',  color:'white', borderRadius:'8px'
                            }}>
                                {usuario.role}
                            </Typography>
                        </Box>

                        <Box sx={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', 
                            mt:3, mb:2, position:'relative',  overflow: 'hidden',
                        }}>
                            <Typography variant="h3" sx={{color:'black', fontSize:19}}>
                                {usuario.nombre} 
                            </Typography>
                            <Typography variant="h3" sx={{color:'black'}}>
                                ID: {usuario.usuario.cedula}
                            </Typography>
                            <Typography variant="h3" sx={{color:'black'}}>
                                RH: { 'O+' }
                            </Typography>
                        </Box>
                    </StyledCard>

                :   <CargandoMedio titulo="Cargando Carnet..."/>
                }


                {/* <Grid container sx={{justifyContent:'center', alignItems:'center'}}>
                    <Grid item xs={10} sm={6} md={4}>
                        <Button variant="contained" fullWidth >Descargar</Button>
                    </Grid>
                </Grid> */}

                <Box sx={{height:20}} />
            </Grid>
         </LayoutReturn>
    )
}

